// Content data for Sri Sode Vadiraja Matha
// Static site - content drawn from official Sode Matha themes.

export const SITE = {
  name: "Sri Sode Vadiraja Matha",
  shortName: "Sode Matha",
  tagline: "Preserving the Eternal Legacy of Sri Vadiraja Theertha and the Dvaita Tradition",
  address: "Sri Sode Vadiraja Matha, Sonda, Sirsi Taluk",
  phone: "+91 9483357005",
  phoneAlt: "+91 8277123333",
  email: "Info@sodematha.in",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3894.32!2d74.7561!3d13.3416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sSri%20Sode%20Vadiraja%20Matha!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const TEMPLE_TIMINGS = [
  { period: "Morning Darshana", periodKn: "ಬೆಳಗಿನ ದರ್ಶನ", time: "5:30 AM - 12:30 PM", timeKn: "ಬೆಳಗ್ಗೆ ೫:೩೦ - ಮಧ್ಯಾಹ್ನ ೧೨:೩೦", note: "Suprabhata • Naivedya • Maha Mangalaarati", noteKn: "ಸುಪ್ರಭಾತ • ನೈವೇದ್ಯ • ಮಹಾ ಮಂಗಳಾರತಿ" },
  { period: "Afternoon Break", periodKn: "ಮಧ್ಯಾಹ್ನ ವಿಶ್ರಾಂತಿ", time: "12:30 PM - 4:00 PM", timeKn: "ಮಧ್ಯಾಹ್ನ ೧೨:೩೦ - ಸಂಜೆ ೪:೦೦", note: "Sanctum closed for rest", noteKn: "ಗರ್ಭಗುಡಿ ವಿಶ್ರಾಂತಿಗಾಗಿ ಮುಚ್ಚಿರುತ್ತದೆ" },
  { period: "Evening Darshana", periodKn: "ಸಂಜೆಯ ದರ್ಶನ", time: "4:00 PM - 9:00 PM", timeKn: "ಸಂಜೆ ೪:೦೦ - ರಾತ್ರಿ ೯:೦೦", note: "Alankara • Deeparadhane • Rangapooja", noteKn: "ಅಲಂಕಾರ • ದೀಪಾರಾಧನೆ • ರಂಗಪೂಜೆ" },
];

export const TODAY_QUICK = {
  seva: "Sarvamoola Grantha Pravachana",
  sevaKn: "ಸರ್ವಮೂಲ ಗ್ರಂಥ ಪ್ರವಚನ",
  festival: "Sri Vadiraja Aradhana preparations",
  festivalKn: "ಶ್ರೀ ವಾದಿರಾಜ ಆರಾಧನೆ ಸಿದ್ಧತೆಗಳು",
};

export const HIGHLIGHTS = [
  { value: "700+", label: "Years of Tradition", labelKn: "ವರ್ಷಗಳ ಪರಂಪರೆ" },
  { value: "8", label: "Ashta Mathas Lineage", labelKn: "ಅಷ್ಟಮಠ ಪರಂಪರೆ" },
  { value: "36+", label: "Guru Parampara", labelKn: "ಗುರುಪರಂಪರೆ" },
  { value: "Global", valueKn: "ಜಾಗತಿಕ", label: "Devotee Community", labelKn: "ಭಕ್ತ ಸಮುದಾಯ" },
  { value: "Countless", valueKn: "ಅಸಂಖ್ಯಾತ", label: "Publications & Grantha", labelKn: "ಪ್ರಕಟಣೆಗಳು ಮತ್ತು ಗ್ರಂಥಗಳು" },
  { value: "Multiple", valueKn: "ಹಲವಾರು", label: "Educational Institutions", labelKn: "ಶೈಕ್ಷಣಿಕ ಸಂಸ್ಥೆಗಳು" },
];

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "About",
    children: [
      { label: "About Sode Matha", to: "/about" },
      { label: "About Sri Bhootharaja", to: "/bhootharaja" },
      { label: "Lineage & Legacy", to: "/lineage" },
      { label: "Branches", to: "/branches" },
    ],
  },
  { label: "Deities", to: "/deities" },
  {
    label: "Activities",
    children: [
      { label: "Publications", to: "/publications" },
      { label: "Institutions", to: "/institutions" },
    ],
  },
  { label: "Events", to: "/events" },
  { label: "Gallery", to: "/gallery" },
  { label: "Sevas", to: "/sevas" },
  { label: "Contact", to: "/contact" },
];

// Curated & VISUALLY-VERIFIED royalty-free imagery
// Using a small trusted set (Unsplash + Pexels) cycled across sections.
// All URLs below have been visually verified as authentic temple/spiritual content.
const T = {
  gopuram: "https://images.unsplash.com/photo-1565195161077-f5c5f61f9ea2?auto=format&fit=crop&w=2000&q=80", // South Indian Gopuram
  facade: "https://images.pexels.com/photos/5103732/pexels-photo-5103732.jpeg?auto=compress&cs=tinysrgb&w=2000", // Tall temple gopuram
  stone: "https://images.pexels.com/photos/31969428/pexels-photo-31969428.jpeg?auto=compress&cs=tinysrgb&w=2000", // Pattadakal stone
  lamps: "https://images.unsplash.com/photo-1771929712047-3e7022669175?auto=format&fit=crop&w=1600&q=80", // Rows of brass oil lamps
  marigoldField: "https://images.pexels.com/photos/14304115/pexels-photo-14304115.jpeg?auto=compress&cs=tinysrgb&w=1600", // Marigold field
  marigoldPattern: "https://images.unsplash.com/photo-1442458017215-285b83f65851?auto=format&fit=crop&w=1600&q=80", // Marigold pattern
};

// Official Sode Matha artefacts provided by devotees
export const OFFICIAL = {
  logo: require("../assets/mhg987df_Sode_Logo-removebg-preview.png"),
  banner: require("../assets/k8q3x0j0_banner_7.webp"),
  homeImage: require("../assets/0qy6jwvx_Home_image.jpg"),
  worship: require("../assets/5ai4ytco_worship.jpeg"),
  hayagriva: require("../assets/9hx1jwk3_SriHayagriva.png"),
  narasimha: require("../assets/lke1riwn_SriLakshmiNarasimha.png"),
  bhuvaraha: require("../assets/wtz4k8zv_SriBhuvaraha.png"),
  vitthala: require("../assets/xjufr45n_SriVitthala.png"),
  paryayaKrishna: require("../assets/npuh61tz_ParyayaSriKrishna.png"),
  srimushnavaraha: require("../assets/78jipc40_Srimushnavaraha.png"),
  vishvambhara: require("../assets/u4ufx78u_SriVishvambharaSaligrama.png"),
  mukhyapranaVadiraja: require("../assets/1gk5j0n7_SriMukhyapranaandSriVadiraj.png"),
  suvarnapaduka: require("../assets/cknagt4s_SuvarnapadukaofSriVadirajar.png"),
  kadugoluKrishna: require("../assets/1kfof539_KadugoluSriKrishna.png"),
  garudavahana: require("../assets/wzxwubcg_GarudavahanaSriLakshmiNaray.png"),
  ramaVitthala: require("../assets/7dzc6mi3_SriRam-Vitthala.png"),
  srinivasa: require("../assets/c68irrew_LordSrinivasawithSriandBhu.png"),
  paccheVitthala: require("../assets/yoms4wod_PaccheVitthala.png"),
  hayagriva2: require("../assets/zedeq12k_SriHayagriva1.png"),
  vyasamushti: require("../assets/gyqqmqyb_SriVyasamushti.png"),
  pontiffPrevious: require("../assets/bkd5w7fh_SriSriVishvothamaSripadaru.webp"),
  pontiffCurrent: require("../assets/xpz7l4c3_Good_one_SriVishwavallabhaSwamiji.png"),
};

export const IMG = {
  heroTemple: OFFICIAL.banner,
  templeCorridor: OFFICIAL.homeImage,
  templeStone: T.stone,
  brassLamp: OFFICIAL.worship,
  marigold: T.marigoldField,
  petals: T.marigoldPattern,
  templeInterior: OFFICIAL.banner,
  deityShrine: T.lamps,
  manuscripts: T.stone,
  processional: OFFICIAL.homeImage,
  students: T.stone,
  yakshagana: T.marigoldField,
  offering: T.marigoldPattern,
  templeBell: T.lamps,
  ganga: OFFICIAL.banner,
  book: T.stone,
  discourse: OFFICIAL.homeImage,
  chariot: OFFICIAL.banner,
  aarti: T.lamps,
  annadana: T.marigoldPattern,
  goSeva: T.marigoldField,
  gurukula: T.stone,
  library: T.stone,
  research: T.lamps,
};

export const CORE_VALUES = [
  { title: "Dharma", titleKn: "ಧರ್ಮ", subtitle: "Righteousness", subtitleKn: "ಸತ್ಯಾಚಾರ", desc: "Preserving Sanatana Dharma through worship, discipline and righteous living.", descKn: "ಪೂಜೆ, ಶಿಸ್ತು ಮತ್ತು ಸತ್ಯಾಚಾರದ ಮೂಲಕ ಸನಾತನ ಧರ್ಮದ ಸಂರಕ್ಷಣೆ.", icon: "Landmark" },
  { title: "Bhakti", titleKn: "ಭಕ್ತಿ", subtitle: "Devotion", subtitleKn: "ಭಕ್ತಿ", desc: "Unwavering devotion centered on Sri Krishna and the teachings of Sri Vadiraja.", descKn: "ಶ್ರೀ ಕೃಷ್ಣ ಹಾಗೂ ಶ್ರೀ ವಾದಿರಾಜರ ಬೋಧನೆಗಳ ಮೇಲಿನ ಅಚಲ ಭಕ್ತಿ.", icon: "Flower2" },
  { title: "Jnana", titleKn: "ಜ್ಞಾನ", subtitle: "Wisdom", subtitleKn: "ವಿವೇಕ", desc: "Propagation of Dvaita Vedanta through study, discourse and manuscript preservation.", descKn: "ಅಧ್ಯಯನ, ಪ್ರವಚನ ಮತ್ತು ಗ್ರಂಥ ಸಂರಕ್ಷಣೆಯ ಮೂಲಕ ದ್ವೈತ ವೇದಾಂತದ ಪ್ರಚಾರ.", icon: "ScrollText" },
  { title: "Seva", titleKn: "ಸೇವೆ", subtitle: "Service", subtitleKn: "ಸೇವೆ", desc: "Serving society through Annadana, education, charity and community upliftment.", descKn: "ಅನ್ನದಾನ, ಶಿಕ್ಷಣ, ಧರ್ಮಾರ್ಥ ಮತ್ತು ಸಮಾಜ ಸೇವೆಯ ಮೂಲಕ ಸಮಾಜ ಸೇವೆ.", icon: "HandHeart" },
  { title: "Samskriti", titleKn: "ಸಂಸ್ಕೃತಿ", subtitle: "Culture", subtitleKn: "ಸಂಸ್ಕೃತಿ", desc: "Nurturing India's classical music, dance, Yakshagana and temple arts.", descKn: "ಭಾರತೀಯ ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತ, ನೃತ್ಯ, ಯಕ್ಷಗಾನ ಮತ್ತು ದೇವಸ್ಥಾನ ಕಲೆಗಳ ಪೋಷಣೆ.", icon: "Music4" },
  { title: "Parampara", titleKn: "ಪರಂಪರೆ", subtitle: "Lineage", subtitleKn: "ವಂಶ", desc: "Continuing an unbroken lineage of Peethadhipatis spanning seven centuries.", descKn: "ಏಳು ಶತಮಾನಗಳಿಂದ ಮುಂದುವರೆದಿರುವ ಪೀಠಾಧಿಪತಿಗಳ ಅಚ್ಛೇದಿತ ಪರಂಪರೆ.", icon: "Sparkles" },
];
